<template>
	<v-app id="inspire" class="workspace-shell">
        <v-navigation-drawer class="workspace-sidebar" v-if="renewalReady && !renewalBlocked" app floating v-model="drawer" width="216">
            <router-link to="/home/index" class="workspace-brand" aria-label="有课丫首页"><img src="../assets/login-brand.svg" alt="有课丫"><span>机构管理平台</span></router-link>
            <v-list dense class="workspace-menu">
                <template v-for="item in filter(global.routeTree)">
                    <v-list-item v-if="!item.children" :key="item.functionId || item.routePath" class="workspace-menu-item" :class="{'workspace-menu-current': item.routePath === $route.path}" @click="$router.push(item.routePath)">
                        <v-list-item-icon><v-icon>{{item.icon}}</v-icon></v-list-item-icon>
                        <v-list-item-title>{{item.functionName}}</v-list-item-title>
                    </v-list-item>
                    <v-list-group v-else :key="item.functionId || item.routePath" :prepend-icon="item.icon || ''" class="workspace-menu-group" :value="item.open" color="#d9363e">
                        <template v-slot:activator><v-list-item-title v-html="item.functionName" /></template>
                        <v-list-item v-for="(admin, i) in item.children" :key="admin.functionId || i" link dense class="workspace-submenu-item" :class="{'workspace-menu-current': admin.routePath === $route.path}" @click="openPage(admin.routePath)">
                            <v-list-item-icon v-if="admin.icon"><v-icon v-text="admin.icon" /></v-list-item-icon>
                            <v-list-item-content><v-list-item-title v-html="admin.functionName" /></v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                </template>
            </v-list>
            <template v-slot:append><div class="workspace-sidebar-note"><img src="../assets/login-brand.svg" alt=""><span>专注教学，轻松管理</span></div></template>
        </v-navigation-drawer>
		<!-- 登录用户信息 -->
		<v-navigation-drawer app right temporary v-model="system">
			<v-list-item>
				<v-list-item-avatar>
					<v-avatar color="orange" size="32">
						<v-img v-if="global.employee.avatar" :src="global.config.imgPre+global.employee.avatar"></v-img>
					</v-avatar>
				</v-list-item-avatar>
				<v-list-item-content>
					<v-list-item-title>{{ global.employee.nickName +'(' + global.employee.trueName + ')' }}
					</v-list-item-title>
					<v-list-item-subtitle>ID:{{ global.employee.employeeNo}}</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>
			<v-divider />
			<v-list dense>
				<v-list-item @click="system = !system">
					<v-list-item-action>
						<v-icon>mdi-close</v-icon>
					</v-list-item-action>
					<v-list-item-content>
						<v-list-item-title>关闭面板</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-list-item @click="changePwd.dialog=true">
					<v-list-item-action>
						<v-icon>mdi-shield-key</v-icon>
					</v-list-item-action>
					<v-list-item-content>
						<v-list-item-title>修改密码</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-list-item @click="logout">
					<v-list-item-action>
						<v-icon>mdi-exit-to-app</v-icon>
					</v-list-item-action>
					<v-list-item-content>
						<v-list-item-title>退出登录</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>
        <v-app-bar app flat height="74" class="workspace-topbar">
            <v-app-bar-nav-icon aria-label="展开或收起导航" @click.stop="drawer = !drawer" />
            <span class="workspace-location">机构工作台</span>
            <v-spacer />
            <v-menu v-model="changeShop.showList" offset-y :close-on-content-click="false" max-height="360" min-width="260" max-width="380" content-class="workspace-campus-menu">
                <template v-slot:activator="{ attrs }">
                    <button v-if="currentShop" type="button" class="workspace-campus" v-bind="attrs" aria-label="切换校区" @click.stop="toChangeShop">
                        <v-avatar v-if="currentShop.shopLogo" size="28"><v-img :src="global.config.imgPre+currentShop.shopLogo" /></v-avatar>
                        <v-icon v-else size="19" color="#d9363e">mdi-map-marker-outline</v-icon>
                        <span class="workspace-campus-name">{{currentShop.shopName}}</span><v-icon size="17">mdi-chevron-down</v-icon>
                    </button>
                </template>
                <v-list nav dense>
                    <v-subheader>切换校区</v-subheader>
                    <v-list-item-group v-model="changeShop.index" active-class="workspace-campus-active">
                        <v-list-item v-for="(item,index) in changeShop.shopList" :key="item.id || index" @click="setCurrentShop(item)">
                            <v-list-item-icon><v-icon size="19">mdi-map-marker-outline</v-icon></v-list-item-icon>
                            <v-list-item-content><v-list-item-title>{{item.shopName}}</v-list-item-title></v-list-item-content>
                            <v-icon v-if="currentShop && item.id == currentShop.id" size="17" color="#d9363e">mdi-check</v-icon>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-menu>
            <span v-if="currentShop" class="workspace-expiry">有效期至 {{currentShop.expireDate}}</span>
            <v-btn v-if="renewalEntryVisible" class="workspace-renew" small outlined color="#c44d52" @click="$refs.renewal.open()">校区续费</v-btn>
            <span class="workspace-topbar-divider" />
            <button type="button" class="workspace-profile" aria-label="账号设置" @click.stop="system = !system"><v-avatar size="32" color="#f0e9e0"><v-img v-if="global.employee.avatar" :src="global.config.imgPre+global.employee.avatar" /><span v-else>{{(global.employee.nickName || global.employee.trueName || '员工').slice(0,1)}}</span></v-avatar><span class="workspace-profile-name">{{global.employee.nickName || global.employee.trueName || '员工'}}</span><v-icon size="16">mdi-chevron-down</v-icon></button>
        </v-app-bar>
		<!-- 主内容区 -->
		<v-main>
			<div class="workspace-route" :class="{'workspace-route-home': $route.path === '/home/index'}">
				<v-alert v-if="accountModes.error" type="warning" dense>{{accountModes.error}} <v-btn text small @click="refreshModes">重试校区配置</v-btn></v-alert>
				<CampusRenewal ref="renewal" :shop-id="currentShop ? currentShop.id : ''" :employee-id="global.employee.id" @access="onRenewalAccess" @logout="logout" />
				<router-view v-if="renewalReady && !renewalBlocked"></router-view>
			</div>
		</v-main>
		<!-- 页脚 -->
		<v-footer app class="workspace-footer">
			<div :span="24" class="bt-footer">
				<span>Copyright © 2022 长沙永芸信息科技有限公司 All Rights Reserved.</span>
				<span class="ml-4">ICP备案号：湘ICP备2022020124号-1</span>
			</div>
		</v-footer>

		<!-- 修改密码 dialog -->
		<v-dialog title="修改密码" v-model="changePwd.dialog" max-width="400" persistent>
			<v-card>
				<v-card-title>修改登录密码</v-card-title>
				<v-card-text>
					<v-row dense>
						<v-col cols="12">
							<v-text-field label="新密码" type="password" v-model="changePwd.newPwd" dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field label="确认密码" type="password" v-model="changePwd.newPwd2" dense outlined>
							</v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="changePwd.dialog=false">取消</v-btn>
					<v-btn @click="submitChangePwd" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>


	</v-app>
</template>

<script>
	import {accountModes,refreshAccountModes,filterAccountMenus} from '../config/accountModes'
	import {mergeGoodsMenus} from '../config/goodsStock'
	import CampusRenewal from "../components/CampusRenewal.vue"
	import global from "../config/global"
	import store from "../config/storage"
	import md5 from "js-md5"
	import {EventBus} from '../config/eventBus'
	export default {
		name: 'layout',
		components: { CampusRenewal },
		data() {
			return {
				accountModes,
				drawer: null,
				system: false,
				global: global,
				store: store,
				search: "",
				changePwd: {
					dialog: false,
					newPwd: "",
					newPwd2: ""
				},
				changeShop: {
					shopList:[],
					showList: false,
					index:0
				},
				currentShop:null,
				renewalReady: false,
				renewalBlocked: true,
				renewalEntryVisible: false
				

			}
		},
		created() {
			this.currentShop = this.store.getCurrentShop();
			EventBus.$on("updateShop", this.updateCurrentShop);
 EventBus.$on("accountModesUpdated", this.refreshModes);
 this.refreshModes();
		},
		beforeDestroy() { EventBus.$off("updateShop", this.updateCurrentShop); EventBus.$off("accountModesUpdated", this.refreshModes); },

		methods: {
			onRenewalAccess(state) {
				this.renewalReady = state.ready;
				this.renewalBlocked = state.blocked;
				// Show renewal in the final 30 days, including expired campuses.
				this.renewalEntryVisible = !!(state.ready && state.current && Number.isFinite(state.current.daysRemaining) && state.current.daysRemaining < 30);
				if (state.ready && state.current && this.currentShop && String(state.current.id) === String(this.currentShop.id)) {
					this.currentShop = { ...this.currentShop, expireDate: state.current.expireDate, status: state.current.status };
					this.store.setCurrentShop(this.currentShop);
				}
			},
			updateCurrentShop() { this.currentShop = this.store.getCurrentShop(); this.refreshModes(); },
 refreshModes() { return refreshAccountModes(this.axios, this.currentShop&&this.currentShop.id); },
			logout() {

				// 调用登出API
				const that = this;
				this.axios.post("/sys/employee/logout", {}).catch(function(e) {

				}).then(function(res) {
					console.log(res);
					if (res && res.data) {
						console.log("logout api res:", res.data);
						if (res.data["code"] === 200) {

							//store.remove(store.config.token);
							store.clear();
							that.$router.push("/login");

						} else {
							that.$noty.error("登录失败:" + res.data["message"]);
						}
					}
				});
			},
			filter(list) {
				// 没有搜索时 处理是否打开文件夹
				if (!this.search) {
					for (let i = 0; i < list.length; i++) {
						list[i].open = this.$route.path.indexOf(list[i].routePath) === 0
					}
					return mergeGoodsMenus(filterAccountMenus(list.filter(v => v.functionId !== ''),this.accountModes.ready?this.accountModes.modes:[]))
				}
			},
			toChangeShop(){
				
				if(this.changeShop.showList){
					this.changeShop.showList = false;
					return
				}
				
				this.changeShop.shopList = (this.global.employee.shopList || []).length ? this.global.employee.shopList : (this.global.employee.renewalShopList || []);
				this.changeShop.showList = true;
				
				let selectedIndex = 0 ;
				this.changeShop.shopList.forEach((item,index)=>{
					if (this.currentShop && item.id == this.currentShop.id){
						selectedIndex = index;
					}
				})
				this.changeShop.index = selectedIndex;
				
			},
			setCurrentShop(item){
				// 切换校区
				if (!this.currentShop || item.id !== this.currentShop.id){
					this.store.setCurrentShop(item);
					// 切换校区 刷新页面
					if (location.href.indexOf("#reloaded") == -1) {
					  location.href = location.href + "#reloaded";
					  location.reload();
					}
				}
				// 没改变 就关闭列表
				this.changeShop.showList = false;

			},
			openPage(path) {
				// console.log("open path:" + path);
				this.$router.push(path);
			},
			submitChangePwd() {
				if (!this.changePwd.newPwd) {
					this.$noty.error("请输入新密码");
					return
				}


				if (!this.changePwd.newPwd2) {
					this.$noty.error("请输入确认新密码");
					return
				}
				if (this.changePwd.newPwd !== this.changePwd.newPwd2) {
					this.$noty.error("两次密码不一致");
					return
				}

				// 调用登出API
				const that = this;
				let newPassword = md5(this.changePwd.newPwd);
				this.axios.post("/sys/employee/password/change", {
					password: newPassword
				}).catch(function(e) {

				}).then(function(res) {
					console.log(res);
					if (res && res.data) {

						if (res.data["code"] === 200) {

							that.changePwd.dialog = false;
							that.$noty.success("修改成功,下次直接使用新密码登录");
							return


						} else {
							that.$noty.error("登录失败:" + res.data["message"]);
						}
					} else {
						that.$noty.error("网络异常");
						return
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/workspace-ui.scss";
</style>
